import React from "react";
import { CardProps } from "../Card/CardProps.csharp";
import { EventCardViewModel } from "./EventCardViewModel.csharp";
import { ResponsivePicture } from "../../ReactComponents/responsivePicture/responsivePicture";
import classNames from "classnames";
import { CardVariant } from "../Card/CardVariant.csharp";

const MetadataDisplay: React.FC<{
    date?: string;
    times: string[];
    tags?: string[];
    isListVariant?: boolean;
}> = ({ date, times, tags, isListVariant }) => {
    if (!date && times.length === 0) return null;

    if (times.length > 0) {
        const maxVisible = 4;
        const visibleTimes = times.slice(0, maxVisible);
        const showEllipsis = times.length > maxVisible;

        return (
            <div className={classNames("multi-time", { "multi-time--list": isListVariant })}>
                {tags &&
                    tags.length > 0 &&
                    tags.map((tag, index) => (
                        <React.Fragment key={`${tag}-${index}`}>
                            <div className="EventCard__tag">{tag}</div>
                            <div className="EventCard__seperator"></div>
                        </React.Fragment>
                    ))}

                {isListVariant && date && <div>{date}</div>}
                <div className="EventCard__seperator"></div>
                <div className="desktop">
                    {!isListVariant && date && <span>{date}, </span>}
                    {visibleTimes.map((time, i) => (
                        <span key={i + time + date}>
                            {time}
                            {i < visibleTimes.length - 1 ? ", " : ""}
                        </span>
                    ))}
                    {showEllipsis && <span>...</span>}
                </div>
                {isListVariant && (
                    <div className="mobile">
                        <span>
                            {visibleTimes.join(", ")}
                            {showEllipsis ? ", ..." : ""}
                        </span>
                    </div>
                )}
            </div>
        );
    }

    return <div>{date}</div>;
};

export const EventCard: React.FC<CardProps> = (props) => {
    const { title, subtitle, picture, location, date, time, url, ticketUrl, ticketText, tags, isSoldOut } =
        props.model as EventCardViewModel;

    const rawTimes = time;
    const times = Array.isArray(rawTimes)
        ? rawTimes
        : typeof rawTimes === "string"
        ? rawTimes.split(",").map((t) => t.trim())
        : [];

    const isListVariant = props.variant === CardVariant.ListItem;

    const ticketsButton = ticketUrl ? <a href={ticketUrl}>{ticketText}</a> : <span>{ticketText}</span>;

    return (
        <div className={classNames("EventCard", isListVariant ? "EventCard--listItem" : "EventCard--withImage")}>
            <a className="EventCard__link" href={url} title={title}>
                <div className="EventCard__intro">
                    {isListVariant && <MetadataDisplay date={date} times={times} tags={tags} isListVariant />}
                    {isSoldOut && isListVariant && <div className="EventCard__soldOut">Sold Out</div>}
                </div>
                <div className="EventCard__content">
                    <div className="CardPicture">
                        <ResponsivePicture profile={props.profile} model={picture} />
                    </div>
                    <div>
                        <h2
                            className={classNames("EventCard__title", {
                                "EventCard__title--featured": !!props.featured,
                            })}
                        >
                            {title}
                            <span className="EventCard__subtitle">{subtitle}</span>
                        </h2>
                        {!isListVariant && (
                            <MetadataDisplay date={date} times={times} tags={tags} isListVariant={false} />
                        )}
                        <div className="EventCard__location">{location}</div>
                    </div>
                    {isListVariant && (
                        <div className="EventCard__seeMore">
                            <div>{ticketsButton}</div>
                        </div>
                    )}
                </div>
            </a>
        </div>
    );
};
